// extracted by mini-css-extract-plugin
module.exports = {"root":"Details_root__3yrCT","content":"Details_content__17Eok","sideBar":"Details_sideBar__27Wyg"};